export const productName = 'RENEWABLE ENERGY COMPLETE COLLECTION';
export const productImage =
  'https://cdn.magicpatterns.com/uploads/knsSXtV1MRtcM4gHT3T5zw/ChatGPT_Image_8_sept_2026,_16_48_40.png';

export const checkoutUrl = 'https://renewable-energy.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Renewable Energy Fundamentals',
  'Volume 2 — Solar Energy',
  'Volume 3 — Wind Energy',
  'Volume 4 — Hydropower & Marine Energy',
  'Volume 5 — Biomass, Bioenergy & Biofuels',
  'Volume 6 — Geothermal & Emerging Renewables',
  'Volume 7 — Energy Storage & Smart Grids',
  'Volume 8 — System Design & Sizing',
  'Volume 9 — Teaching Renewable Energy',
  'Bonus 1 — 150 Classroom Activities',
  'Bonus 2 — 100 Solved Problems',
  'Bonus 3 — Complete Assessment Suite',
  'Bonus 4 — 50 Projects & STEM Challenges',
  'Bonus 5 — Visual Component Guide',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex renewable energy concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see the relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
